






























import Vue from "vue";

import IconTrophyTitle from "@joyz/app-core/assets/icons/default/Chart.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/white/Close.svg";
import IconCorrect from "@joyz/app-core/assets/icons/white/Check.svg";

import TrophyBronzeStandard from "@joyz/app-core/assets/trophy/gif/Bronze.gif";
import TrophyBronzeNewRecord from "@joyz/app-core/assets/trophy/gif/BronzeNewRecord.gif";
import TrophySilverStandard from "@joyz/app-core/assets/trophy/gif/Silver.gif";
import TrophySilverNewRecord from "@joyz/app-core/assets/trophy/gif/SilverNewRecord.gif";
import TrophyGoldStandard from "@joyz/app-core/assets/trophy/gif/Gold.gif";
import TrophyGoldNewRecord from "@joyz/app-core/assets/trophy/gif/GoldNewRecord.gif";
import { TrophyState } from "@tt-app/models/exercise";

interface Props {
  iconTrophyTitle: string;
  iconIncorrect: string;
  iconCorrect: string;
  trophy: TrophyState;
}

interface Computed {
  trophyEffectiveUrl: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "ChatTrophy",

  props: {
    iconTrophyTitle: { type: String, default: IconTrophyTitle },
    iconIncorrect: { type: String, default: IconIncorrect },
    iconCorrect: { type: String, default: IconCorrect },
    trophy: { type: Object as () => TrophyState, required: true }
  },

  computed: {
    trophyEffectiveUrl(): string {
      if (this.trophy.imgUrl) {
        return this.trophy.imgUrl;
      }

      // http://joyz-internal-documentation.s3-website-ap-northeast-1.amazonaws.com/projects/private/tt4w/tt4w.html#exercise-trophy
      switch (this.trophy.score) {
        case 1:
          return this.trophy.newRecord ? TrophyBronzeNewRecord : TrophyBronzeStandard;
        case 2:
          return this.trophy.newRecord ? TrophySilverNewRecord : TrophySilverStandard;
        case 3:
          return this.trophy.newRecord ? TrophyGoldNewRecord : TrophyGoldStandard;
        default:
          throw new Error(`ChatTrophy must have either a TrophyImgUrl or a TrophyScore`);
      }
    }
  }
});
